import { AvailableShareUser, AvailableShareUserGroup, ShareUser, ShareUserGroup } from './types';

export const capitalize = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1);

export const buildDisplayName = (givenName: string, familyName: string, email: string): string => {
  if (givenName && familyName) {
    return `${capitalize(familyName)} ${capitalize(givenName)}`;
  }
  return email;
};

export const getWordEnding = (count: number, word: string): string => (count < 2 ? word : `${word}s`);

export const buildSharedWithMessage = (userCount: number, userGroupCount: number): string => {
  const userCountWord = `${userCount} ${getWordEnding(userCount, 'user')}`;
  const separator = userCount && userGroupCount ? ' and ' : '';
  const userGroupCountWord = `${userGroupCount} ${getWordEnding(userGroupCount, 'group')}`;
  return `${userCount ? userCountWord : ''}${separator}${userGroupCount ? userGroupCountWord : ''}`;
};

export const buildUserGroupDescription = (userGroup: ShareUserGroup | AvailableShareUserGroup): string => {
  return `Group — ${userGroup.usersCount} ${getWordEnding(userGroup.usersCount, 'user')}`;
};

export const getShareEntityId = (shareEntity: ShareUser | ShareUserGroup): string => {
  return (shareEntity as ShareUser).userId || (shareEntity as ShareUserGroup).userGroupId?.toString();
};

export const sortAvailableShareUsers = (a: AvailableShareUser, b: AvailableShareUser) =>
  buildDisplayName(a.givenName, a.familyName, a.email)?.toLowerCase() >
  buildDisplayName(b.givenName, b.familyName, b.email)?.toLowerCase()
    ? 1
    : -1;

export const sortAvailableShareUserGroups = (a: AvailableShareUserGroup, b: AvailableShareUserGroup) =>
  a.userGroupName?.toLowerCase() > b.userGroupName?.toLowerCase() ? 1 : -1;

export const mapAvailableShareUserToSelectOption = (
  user: ShareUser
): { label: string; value: string; description?: string } => {
  const displayName = buildDisplayName(user.givenName, user.familyName, user.email);
  return {
    label: displayName,
    value: user.userId,
    description: displayName !== user.email ? user.email : undefined,
  };
};

export const mapAvailableShareUserGroupToSelectOption = (
  userGroup: ShareUserGroup
): { label: string; value: string; description: string } => {
  return {
    label: userGroup.userGroupName,
    value: userGroup.userGroupId?.toString(),
    description: buildUserGroupDescription(userGroup),
  };
};
